import angular from 'angular';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  merge: state.user.activeMerge,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:mergeDetailController
 * @description
 * # mergeDetailController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('mergeDetailController', ($ngRedux, $scope, $rootScope, $timeout, $http, ENV, $interval) => {
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.close = () => {
      $rootScope.isMergeDetailDisplay = false;
      $rootScope.closeComponent();
    };

    $scope.generateUserRoute = () => {
      return `${$rootScope.routes.user}/${$scope.user.id}`;
    };

    let mergePromise;
    $scope.pollMergeStatus = () => {
      // if promise exists, cancel it to prevent duplication of intervals
      if (angular.isDefined(mergePromise)) {
        $interval.cancel(mergePromise);
        mergePromise = undefined;
      }
      mergePromise= $interval(() => {
        $scope.getMergeStatus();
      }, 6000);
    }

    $scope.getMergeStatus = () => {
      $scope
      .getMerge($http, ENV, $rootScope.userId, $scope.merge.id)
      .then((res) => {
        $scope.$apply(() => {
          $scope.checkMergeStatus();
        });
      });
    };

    $scope.checkMergeStatus = () => {
      if (!$scope.merge.merge_completed){
        $scope.pollMergeStatus();
      } else if ($scope.merge.merge_completed) {
        $interval.cancel(mergePromise);
        $rootScope.refreshLoyaltyStatistics();
        $rootScope.getData();
        $scope.getUser($http, ENV, $rootScope.userId);
      }
    }

    const userIdListener = $rootScope.$watch('isMergeDetailDisplay', () => {
      if ($rootScope.isMergeDetailDisplay && $rootScope.userId) {
        $scope.checkMergeStatus();
      }
    });

    $scope.init();

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      $interval.cancel(mergePromise);
      userIdListener();
    });
  })
  .directive('mergeDetail', () => {
    return {
      templateUrl: 'templates/v2/merge-detail.html',
    };
  });
